import React, { useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../Hooks';
import { Loader } from '../common/Loader';
import { Col, Row, Form } from 'react-bootstrap';
import { submitFeedbackData } from '../../features/ContactUs';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

const FeedbackForm: React.FC = () => {
    const dispatch = useAppDispatch();
    const { feedbackLoader } = useAppSelector(state => state.contactUs);
    const [contactFormData, setContactFormData] = useState<any>({ first_name: "", last_name: "", customer_designation: "", feedback: "" });
    const [image, setImage] = useState<File | null>();
const {t} = useTranslation()


    // useEffect(() => {
    //     const input = inputRef.current;
    //     if (input) {
    //         itiRef.current = intlTelInput(input, {
    //             initialCountry: 'in',
    //             separateDialCode: true,
    //         });

    //         return () => {
    //             // Cleanup: destroy the intl-tel-input instance
    //             itiRef.current?.destroy();
    //         };
    //     }
    // }, [status]);
    console.log(image, 'image');

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setContactFormData({
            ...contactFormData,
            [name]: value,
        });

    }
    const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files ? e.target.files[0] : null;
        if (file) {

            setImage(file)
        }

    }
    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (!contactFormData.first_name) {
            toast.error("Fisrt Name is Required")
            return
        }
        if (!contactFormData.last_name) {
            toast.error("Last Name is Required")
            return
        }
        const formData = new FormData();
        formData.append('customer_name', `${contactFormData.first_name} ${contactFormData.last_name} `);
        formData.append('customer_designation', contactFormData.customer_designation);
        formData.append('feedback', contactFormData.feedback);
        if (image) {
            formData.append('customer_image', image); // Append the binary file
        }
        dispatch(submitFeedbackData(formData)).then((res) => {

            setContactFormData({
                first_name: '',
                last_name: '',
                customer_designation: '',
                feedback: '',
            });
            setImage(null);
        }).catch((err) => {
            console.log(err, 'err');

        })
    }


    if (feedbackLoader) {
        return <Loader />;
    }

    return (
        <section className='contact-section'>
            <div className="container">
                <Row className='flex-revers'>
                    <Col md={12} lg={6} >
                        <div className="contact-form">
                            <div className='form-heading'>
                                <h3 className='title'>{t('contactus.feedback_title')}</h3>
                                <p className='text'>{t('contactus.feedback_description')}</p>
                            </div>
                            <Form onSubmit={(e) => handleSubmit(e)}>
                                <Row>
                                    <Col md={6}>
                                        <div className="form-group">
                                            <input
                                                type="text"
                                                placeholder={t('contactus.contact.first_name')}
                                                id="first_name"
                                                name="first_name"
                                                value={contactFormData.first_name}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className="form-group">
                                            <input
                                                type="text"
                                                placeholder={t('contactus.contact.last_name')}
                                                id="last_name"
                                                name="last_name"
                                                value={contactFormData.last_name}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className="form-group">
                                            <input
                                                style={{ padding: '12px' }}
                                                className='filetype'
                                                type="file"
                                                id="image"
                                                name="image"
                                                onChange={handleImageChange}
                                            />
                                            {image && (
                                                <img
                                                    style={{ width: '200px', height: '200px' }}

                                                    src={URL.createObjectURL(image)}
                                                    alt="Preview"
                                                    className="img-preview mt-3"
                                                />
                                            )}
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className="form-group">
                                            <input
                                                type="text"
                                                placeholder={t('contactus.feedback.designation')}
                                                id="customer_designation"
                                                name="customer_designation"
                                                value={contactFormData.customer_designation}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className="form-group">
                                            <textarea
                                                placeholder={t('contactus.feedback.feedback')}
                                                id="feedback"
                                                name="feedback"
                                                value={contactFormData.feedback}
                                                onChange={handleInputChange}
                                            ></textarea>
                                        </div>
                                    </Col>
                                    <Col md={3}>
                                        <button type="submit" className="btn btn-gold">
                                        {t('contactus.feedback.button')}
                                        </button>
                                    </Col>
                                </Row>
                            </Form>
                        </div>
                    </Col>
                    <Col md={12} lg={6}>
                        <div className="contact-img">
                            <img src={require('../../assets/images/contact-img.jpg')} alt="img" className="img-fluid"></img>
                        </div>
                    </Col>

                </Row>
            </div>
        </section>
    )
}

export default FeedbackForm;